// src/components/common/Button.js
import { forwardRef } from 'react'
import { Slot } from '@radix-ui/react-slot'

const variants = {
  primary: 'bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-lg shadow-blue-500/25 hover:from-blue-700 hover:to-blue-800 hover:shadow-blue-500/40 focus:ring-blue-500',
  secondary: 'bg-white text-gray-700 border border-gray-200 shadow-sm hover:bg-gray-50 hover:border-gray-300 focus:ring-blue-500',
  accent: 'bg-gradient-to-r from-purple-600 to-purple-700 text-white shadow-lg shadow-purple-500/25 hover:from-purple-700 hover:to-purple-800 focus:ring-purple-500',
  danger: 'bg-gradient-to-r from-red-600 to-red-700 text-white shadow-lg shadow-red-500/25 hover:from-red-700 hover:to-red-800 focus:ring-red-500',
  success: 'bg-gradient-to-r from-green-600 to-green-700 text-white shadow-lg shadow-green-500/25 hover:from-green-700 hover:to-green-800 focus:ring-green-500',
  ghost: 'text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:ring-gray-300',
  outline: 'border-2 border-blue-200 text-blue-700 hover:bg-blue-50 hover:border-blue-300 focus:ring-blue-500'
}

const sizes = {
  xs: 'px-2.5 py-1.5 text-xs',
  sm: 'px-3 py-2 text-sm',
  md: 'px-4 py-2.5 text-sm',
  lg: 'px-6 py-3 text-base',
  xl: 'px-8 py-4 text-lg'
}

const Button = forwardRef(({
                             variant = 'primary',
                             size = 'md',
                             children,
                             className = '',
                             disabled = false,
                             asChild = false,
                             ...props
                           }, ref) => {
  const Comp = asChild ? Slot : 'button'

  return (
      <Comp
          ref={ref}
          className={`
        inline-flex items-center justify-center font-medium rounded-xl
        focus:outline-none focus:ring-2 focus:ring-offset-2
        disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none
        transition-all duration-200 ease-in-out
        transform hover:scale-[1.02] active:scale-[0.98]
        ${variants[variant]}
        ${sizes[size]}
        ${className}
      `}
          disabled={disabled}
          {...props}
      >
        {children}
      </Comp>
  )
})

Button.displayName = 'Button'

export default Button
